import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {CustomsValidators} from '../../validators/custom.validators';


@Injectable({
  providedIn: 'root'
})
export class AdminZoneService {
  urlZoneAdmin: string;
  urlZoneAdminQDummy: string;
  urlAdminApprover: string;
  urlFacilityZone: string;

  constructor(private http: HttpClient) {
    this.urlZoneAdmin = `${environment.bffBaseUrl}/pages/admin-zones`;
    this.urlZoneAdminQDummy = `${environment.bffBaseUrl}/pages/admin-zones/qualification/`;
    this.urlAdminApprover = `${environment.bffBaseUrl}/pages/approvers-subzone`;
    this.urlFacilityZone = `${environment.bffBaseUrl}/pages/admin-zones/Facilities/`;
  }

  getAdminZoneList(id, page, limit) {
    const urlBuilder = this.urlZoneAdmin + '?siteId=' + id + '&page=' + page + '&limit=' + limit + '&desc=false';
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  postAdminZone(zone, siteId) {
    const urlBuilder = this.urlZoneAdmin;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, {
      Name: zone.Name,
      CodeCC: zone.CodeCC,
      Code1Sap: zone.Code1Sap,
      Description: zone.Description,
      isEnabled: zone.isEnabled,
      SiteId: parseInt(siteId, 10)
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

  putAdminZone(zone) {
    const urlBuilder = this.urlZoneAdmin + '/' + zone.Id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.put(urlBuilder, {
      Id: zone.Id,
      SiteId: zone.SiteId,
      Name: zone.Name,
      CodeCC: zone.CodeCC,
      Code1Sap: zone.Code1Sap,
      Description: zone.Description,
      isEnabled: zone.isEnabled
    }) : throwError(CustomsValidators.msgNotValidUrl);

  }

  // ----------qualificationdummy

  getAdminZoneDummy(id) {
    const urlBuilder = this.urlZoneAdminQDummy + id;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  postAdminZoneDummy(Data): Observable<any> {
    const urlBuilder = this.urlZoneAdminQDummy + Data.zoneId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, Data) : throwError(CustomsValidators.msgNotValidUrl);
  }

  putAdminZoneDummy(Data): Observable<any> {
    const urlBuilder = this.urlZoneAdminQDummy + Data.zoneId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.put(urlBuilder, Data) : throwError(CustomsValidators.msgNotValidUrl);

  }


  // ----------------facility
  getFacility(idZone) {
    const urlBuilder = this.urlFacilityZone + idZone;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

  patchFacility(request) {
    const urlBuilder = this.urlFacilityZone + request.zoneId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.patch(urlBuilder, request) : throwError(CustomsValidators.msgNotValidUrl);
  }


  searchApprover(type, ID, nationality, siteId): Observable<any> {
    let national = '';
    if (nationality !== '') {
      national = '&nationality=' + nationality;
    }
    const urlBuilder = this.urlAdminApprover + '/validate' + '?documentType=' + type + '&documentNumber=' + ID
      + national + '&siteId=' + siteId;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder) : throwError(CustomsValidators.msgNotValidUrl);
  }

}
